import React from 'react';
import { Navigate, useLocation } from "react-router-dom"
import { useAuthState } from "react-firebase-hooks/auth"
import { auth } from "lib/firebase"

const ProtectedRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth)
  const location = useLocation()

  if (loading) {
    return <>Loading...</> // Show loading state while checking auth status
  }

  if (!user) {
    // Save the location they were trying to access
    return <Navigate to="/signin" state={{ from: location }} replace />
  }

  return children
}

export default ProtectedRoute;